import { Translation } from '../types';

export const sv: Translation = {
  common: {
    loading: 'Laddar...',
    error: 'Fel',
    cancel: 'Avbryt',
    save: 'Spara',
    close: 'Stäng',
    search: 'Sök',
    reload: 'Ladda om',
    logout: 'Logga ut',
    dashboard: 'Instrumentpanel',
    products: 'Produkter',
    settings: 'Inställningar',
    language: 'Språk',
    businessHours: 'Öppettider',
    back: 'Tillbaka',
    selectAll: 'Välj alla',
    deselectAll: 'Avmarkera alla',
    success: 'Lyckades',
    selected: 'Vald',
    confirm: 'Bekräfta',
    required: 'Obligatorisk',
    requiredMarker: '*',
    previous: 'Föregående',
    next: 'Nästa',
    allRightsReserved: 'Alla rättigheter förbehållna.',
  },
  auth: {
    login: 'Logga in',
    email: 'E-postadress',
    password: 'Lösenord',
    loginButton: 'Logga in',
    loggingIn: 'Loggar in...',
    loginSuccess: 'Inloggningen lyckades',
    loginError: 'Fel e-post eller lösenord',
    invalidEmail: 'Ange en giltig e-postadress',
    requiredFields: 'Fyll i alla obligatoriska fält',
    demoAccount: 'Demokonto:',
    loginDescription: 'Ange dina kontouppgifter för att logga in',
    welcomeMessage: 'Välkommen till företagsbeställningssystemet',
    // Registration
    register: 'Registrera',
    createAccount: 'Skapa konto',
    confirmPassword: 'Bekräfta lösenord',
    passwordRequirements: 'Lösenordet måste vara minst 8 tecken med versaler, gemener, siffror och specialtecken',
    passwordsDoNotMatch: 'Lösenorden matchar inte',
    registrationSuccess: 'Registreringen lyckades',
    registrationDescription: 'Registrera ett företagskonto',
    alreadyHaveAccount: 'Har du redan ett konto?',
    signIn: 'Logga in',
    dontHaveAccount: 'Har du inget konto?',
    creatingAccount: 'Skapar konto...',
    registrationNote: 'Obs:',
    registrationNotePoints: {
      erpLinking: 'Om du har ett befintligt företagskonto kommer din e-post automatiskt att länkas',
      companyEmail: 'Använd din företagse-postadress för registrering',
      contactSupport: 'Kontakta support om du behöver hjälp med registreringen'
    },
    b2bUsers: 'Företagskontoaanvändare:',
    registeredEmail: 'Registrerad e-postadress',
    registeredPassword: 'Lösenord som angavs vid registreringen',
    b2bCustomerRequired: 'Denna e-postadress är inte registrerad som företagskund. Kontakta säljavdelningen först för att etablera en affärsrelation.',
    b2bVerificationError: 'Kunde inte verifiera företagskundstatus. Kontakta support.',
    // Password Reset
    passwordReset: 'Återställ lösenord',
    passwordResetDescription: 'Ange din e-postadress för att få ett tillfälligt lösenord',
    getTemporaryPassword: 'Få tillfälligt lösenord',
    processing: 'Bearbetar...',
    passwordResetComplete: 'Lösenordsåterställning klar',
    temporaryPasswordGenerated: 'Tillfälligt lösenord har genererats',
    temporaryPassword: 'Tillfälligt lösenord',
    backToLogin: 'Tillbaka till inloggning',
    securityNotice: 'Säkerhetsmeddelande:',
    securityNotePoints: {
      keepSecret: 'Dela inte det tillfälliga lösenordet med andra',
      changeAfterLogin: 'Se till att ändra ditt lösenord efter inloggning',
      expires24Hours: 'Det tillfälliga lösenordet upphör att gälla efter 24 timmar'
    },
    resetNote: 'Obs:',
    resetNotePoints: {
      registeredEmail: 'Ange din registrerade e-postadress',
      passwordDisplayed: 'Det tillfälliga lösenordet visas på skärmen',
      changeRequired: 'Lösenordsbyte krävs efter inloggning'
    },
    copied: 'Kopierat',
    copySuccessMessage: 'Tillfälligt lösenord kopierat till urklipp.',
    forgotPassword: 'Glömt lösenord?',
    // Password Reset Email Request
    sendResetLink: 'Skicka återställningslänk',
    sendingEmail: 'Skickar e-post...',
    emailSent: 'E-post skickat',
    emailSentMessage: 'Om denna e-postadress finns i vårt system kommer du snart att få en länk för lösenordsåterställning.',
    emailNotSent: 'E-post inte skickat',
    emailSentInfo: 'Kontrollera din inkorg och skräppostmapp',
    checkEmail: 'Kontrollera e-post',
    emailInstructions: 'Instruktioner för lösenordsåterställning har skickats',
    nextSteps: 'Nästa steg:',
    nextStepsList: {
      checkInbox: 'Kontrollera din inkorg och skräppostmapp',
      clickLink: 'Klicka på återställningslänken i e-postmeddelandet',
      linkExpires: 'Länken upphör att gälla om 24 timmar',
      contactSupport: 'Kontakta support om du inte får e-postmeddelandet',
      rateLimitInfo: 'Begränsat till 3 förfrågningar per timme'
    },
    // Password Reset Completion
    resetLinkSent: 'Återställningslänk skickad',
    resetSuccess: 'Lösenordet har återställts',
    passwordUpdated: 'Lösenord uppdaterat',
    passwordUpdateMessage: 'Ditt lösenord har uppdaterats. Du kan nu logga in med ditt nya lösenord.',
    loginWithNewPassword: 'Logga in med nytt lösenord',
    // Reset Token Page
    resetToken: 'Återställ lösenord',
    invalidToken: 'Ogiltig återställningskod',
    expiredToken: 'Återställningskoden har upphört att gälla',
    tokenValid: 'Återställningskoden är giltig',
    newPassword: 'Nytt lösenord',
    confirmNewPassword: 'Bekräfta nytt lösenord',
    updatePassword: 'Uppdatera lösenord',
    updatingPassword: 'Uppdaterar lösenord...',
    passwordMismatch: 'Lösenorden matchar inte',
    resetInstructions: 'Ange ditt nya lösenord för att slutföra återställningen',
  },
  accountInfo: {
    title: 'Kontoinformation',
    loading: 'Laddar kontoinformation...',
    error: 'Fel',
    errorMessage: 'Kunde inte hämta kontoinformation',
    back: 'Tillbaka',
    basicInfo: 'Grundläggande information',
    name: 'Namn',
    email: 'E-postadress',
    contactId: 'Knitido-kund-ID',
    contactNumber: 'Kontaktnummer',
    noInfo: 'Ingen information',
    companyInfo: 'Företagsinformation',
    company: 'Företagsnamn',
    position: 'Befattning',
    vatId: 'Momsnummer',
    billingAddress: 'Faktureringsadress',
    deliveryAddress: 'Leveransadress',
    addressInfo: 'Adressinformation',
    billingDescription: 'Adress för fakturor och avtalsdokument',
    deliveryDescription: 'Standardleveransadress för produktleveranser',
    sameAsBilling: '※ Samma som faktureringsadress',
    sameAsDelivery: '※ Samma som leveransadress',
    companyName: 'Företagsnamn',
    contactPerson: 'Kontaktperson',
    address: 'Adress',
    phoneNumber: 'Telefonnummer',
    billingUsage: 'Används för fakturor, avtal och andra viktiga dokument',
    deliveryUsage: 'Används som standardleveransadress för beställda produkter',
    alsoUsedForDelivery: 'Används även som leveransadress',
    accountType: 'Kontotyp',
    addressId: 'Adress-ID',
    // Address editing functionality
    edit: 'Redigera',
    editDeliveryAddress: 'Redigera leveransadress',
    editDeliveryDescription: 'Uppdatera din leveransadressinformation',
    newDeliveryAddress: 'Lägg till ny leveransadress',
    newDeliveryDescription: 'Ange detaljerna för din nya leveransadress',
    noDeliveryAddress: 'Ingen leveransadress konfigurerad',
    success: 'Lyckades',
    addressUpdated: 'Leveransadressen har uppdaterats',
    updateError: 'Kunde inte uppdatera leveransadressen',
    requiredFields: 'Fyll i alla obligatoriska fält',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    streetAddress: 'Gatuadress',
    streetAddress2: 'Gatuadress 2',
    city: 'Stad',
    country: 'Land',
    selectCountry: 'Välj land...',
    searchCountry: 'Sök land...',
    noCountryFound: 'Inget land hittades.',
    postalCode: 'Postnummer',
    companyNamePlaceholder: 'Ange företagsnamn',
    firstNamePlaceholder: 'Förnamn',
    lastNamePlaceholder: 'Efternamn',
    streetAddressPlaceholder: 'Ange gatuadress',
    streetAddress2Placeholder: 'Lägenhet, svit, etc.',
    cityPlaceholder: 'Ange stad',
    postalCodePlaceholder: 'Ange postnummer',
    billingNotEditable: 'Faktureringsadressen kan inte redigeras.',
    billingContactSupport: 'Kontakta support för ändringar.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} leveransadresser',
    noDeliveryAddresses: 'Inga leveransadresser registrerade',
    defaultAddress: 'Standard',
    selectDeliveryAddress: 'Välj leveransadress',
    addNewAddress: 'Lägg till ny adress',
    editAddress: 'Redigera adress',
    deleteAddress: 'Ta bort adress',
    confirmDelete: 'Bekräfta borttagning',
    confirmDeleteMessage: 'Är du säker på att du vill ta bort denna adress? Denna åtgärd kan inte ångras.',
    addressAddedSuccess: 'Leveransadress tillagd',
    addressDeletedSuccess: 'Leveransadress borttagen',
    deleteError: 'Kunde inte ta bort leveransadress',
    saving: 'Sparar...',
    cancel: 'Avbryt',
    saveChanges: 'Spara ändringar',
    selectedDeliveryAddress: 'Vald leveransadress',
  },
  dashboard: {
    title: 'Affärspartner',
    subtitle: 'Produktbeställningssystem',
    welcome: 'Välkommen,',
    welcomeMessage: 'Välkommen till affärspartners beställningssystem. Du kan beställa produkter här.',
    productCatalog: 'Produktkatalog',
    productCatalogDesc: 'Bläddra och beställ tillgängliga produkter',
    viewProducts: 'Visa produkter',
    orderHistory: 'Orderhistorik',
    orderHistoryDesc: 'Visa tidigare beställningar',
    accountSettings: 'Kontoinställningar',
    accountSettingsDesc: 'Hantera kontoinformation',
    comingSoon: 'Kommer snart',
    infoTitle: 'Om användning',
    orderingInfo: 'Produktbeställning',
    orderingDesc: 'Välj produkter från katalogen och ange storlek och färg. Lagerinformation finns tillgänglig i realtid.',
    supportInfo: 'Support',
    supportDesc: 'Kontakta oss om du har frågor.',
    viewOrderHistory: 'Visa orderhistorik',
    viewOrders: 'Visa beställningar',
    accountInfo: 'Kontoinformation',
    accountInfoDesc: 'Visa dina kontouppgifter',
    viewDetails: 'Visa detaljer',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Måndag-fredag 9:00 - 15:00 CET',
    bulkImportDesc: 'Importera beställningar från Excel/CSV-filer',
    importOrders: 'Importera beställningar',
  },
  products: {
    title: 'Produktlista',
    subtitle: 'Affärspartner',
    searchPlaceholder: 'Sök efter produktnamn eller SKU...',
    productId: 'Produkt-ID',
    addToCart: 'Lägg i varukorg',
    selectVariation: 'Välj variant',
    price: 'Pris',
    priceNetNotice: 'Alla priser är exklusive moms',
    stock: 'Lager',
    color: 'Färg',
    newProducts: 'Nya Produkter',
    newProductBadge: 'NY',
    size: 'Storlek',
    quantity: 'Antal',
    total: 'Totalt',
    cart: 'Varukorg',
    checkout: 'Till kassan',
    csvMode: 'CSV-snabbläge',
    csvInfo: 'Produktdata hämtat från CSV-data',
    csvUploadDate: 'CSV-uppladdningsdatum:',
    stockNote: '※ Lagerinformation hämtas när produktvarianter väljs',
    noProducts: 'Inga produkter hittades',
    noProductsDesc: 'Ändra sökkriterier eller ladda upp en CSV-fil för snabbare prestanda.',
    retry: 'Försök igen',
    pagination: 'artiklar',
    variations: 'varianter',
    stockFetchError: 'Lagerinhämtningsfel',
    stockFetchFailed: 'Lagerinhämtning misslyckades',
    stockFetchFailedDesc: 'Kunde inte hämta lagerinformation. CSV-lager kommer att visas.',
    stockFetched: 'Lagerinformation hämtad',
    totalStock: 'Totalt lager',
    noStockAll: 'Alla varianter har noll i lager',
    noStockData: 'Inga lagerdata returnerades',
    stockFetchErrorDesc: 'Fel uppstod vid hämtning av lagerinformation',
    selectionError: 'Urvalsfel',
    enterQuantity: 'Ange antal',
    addedToCart: 'Tillagt i varukorgen',
    typesAdded: ' produkttyper tillagda',
    addToCartError: 'Fel vid tillägg till varukorg',
    addToCartErrorDesc: 'Försök igen',
    loadingStock: 'Laddar lagerinformation',
    csvDataInfo: 'Visar CSV-datainformation (inte faktiska lagernivåer)',
    invalidDataFormat: 'Produktdataformatet är ogiltigt',
    loadFailed: 'Kunde inte ladda produktdata',
    csvUploadComplete: 'CSV-uppladdning klar',
    csvLoadedDesc: ' produktdata laddade. Lagerinformation kommer att hämtas när produkter väljs.',
    searchTitle: 'Produktsökning',
    loadingProducts: 'Laddar produktdata',
    noProductsCsv: 'Inga produkter hittades i CSV-data. Ändra sökkriterier.',
    paginationDisplay: ' visas',
    previous: 'Föregående',
    next: 'Nästa',
    selectionSummary: 'Urvalssammanfattning',
    selectedQuantity: 'Vald mängd',
    items: ' artiklar',
    viewDetails: 'Visa detaljer',
    productImage: 'Produktbild',
    correspondingVariations: 'Motsvarande varianter',
    clickToEnlarge: 'Klicka för att förstora',
    productIdLabel: 'Produkt-ID',
    colorLabel: 'Färg',
    filterByCategory: 'Filtrera efter kategori',
    allProducts: 'Alla produkter',
    applyFilters: 'Tillämpa filter',
    clearFilters: 'Rensa filter',
    filters: 'Filter',
    clearAll: 'Rensa alla',
  },
  categories: {
    category_21: 'Tåstrumpor',
    category_23: 'Okategoriserad',
    category_24: 'Kroppskläder',
    category_29: 'B2B-produkter',
  },
  productDetail: {
    title: 'Produktdetaljer',
    backToProducts: 'Tillbaka till produkter',
    productNotFound: 'Produkt hittades inte',
    productNotFoundDesc: 'Den angivna produkten finns inte eller har tagits bort.',
    loading: 'Laddar produkt...',
    imageLoadError: 'Kunde inte ladda bilder',
    noImages: 'Inga bilder tillgängliga',
    productDescription: 'Produktbeskrivning',
    colors: 'Färger',
    sizes: 'Storlekar',
    colorCount: 'färger',
    sizeCount: 'storlekar',
    variationCount: 'varianter',
    selectVariation: 'Välj varianter',
    descriptionLanguageNote: '※ Produktbeskrivningar finns endast på engelska eller tyska',
  },
  colors: {
    schwarz: 'Svart',
    weiß: 'Vit',
    grau: 'Grå',
    rot: 'Röd',
    blau: 'Blå',
    grün: 'Grön',
    gelb: 'Gul',
    rosa: 'Rosa',
    lila: 'Lila',
    braun: 'Brun',
    orange: 'Orange',
    beige: 'Beige',
    navy: 'Marinblå',
    dunkelblau: 'Mörkblå',
    hellblau: 'Ljusblå',
    dunkelgrau: 'Mörkgrå',
    hellgrau: 'Ljusgrå',
    bordeaux: 'Vinröd',
    türkis: 'Turkos',
    khaki: 'Kaki',
    mint: 'Mint',
    violett: 'Violett',
    anthrazit: 'Antracit',
    blaugrau: 'Blågrå',
    burgunderrot: 'Burgundisk',
    elfenbein: 'Elfenben',
    karminrot: 'Karminröd',
    neongrün: 'Neongrön',
    gelbgrün: 'Gulgrön',
    pistazie: 'Pistasch',
    // Engelska färgnamn (används i Product ID 237, etc.)
    blue: 'Blå',
    ivory: 'Elfenben',
    green: 'Grön',
    gold: 'Guld',
    red: 'Röd',
  },
  checkout: {
    title: 'Kassa',
    cartReview: 'Orderöversikt',
    orderSummary: 'Ordersammanfattning',
    shippingInfo: 'Leveransinformation',
    billingInfo: 'Faktureringsinformation',
    orderNotes: 'Orderanteckningar',
    orderNotesPlaceholder: 'Särskilda önskemål eller anteckningar...',
    contactPerson: 'Kontaktperson',
    phoneNumber: 'Telefonnummer',
    email: 'E-postadress',
    company: 'Företag',
    address: 'Adress',
    city: 'Stad',
    postalCode: 'Postnummer',
    country: 'Land',
    deliveryDate: 'Leveransdatum',
    urgentDelivery: 'Expressleverans (3-5 arbetsdagar)',
    standardDelivery: 'Standardleverans (7-10 arbetsdagar)',
    placeOrder: 'Lägg beställning',
    backToCart: 'Tillbaka till produktval',
    requiredField: 'Obligatoriskt fält',
    orderTotal: 'Ordertotal',
    subtotal: 'Delsumma',
    priceNetNotice: 'Alla priser är exklusive moms',
    stockReservationNotice: 'Lagerreservation görs efter orderbekräftelse.',
    stockCheckError: 'Lagerkontrollfel',
    stockCheckErrorDesc: 'Fel uppstod under lagerkontroll. Försök igen.',
    shipping: 'Frakt',
    shippingCost: 'Fraktkostnad',
    tax: 'Moms',
    orderSuccess: 'Order lyckad',
    orderSuccessMessage: 'Din beställning har skickats. Ordernummer: {orderNumber}',
    orderNumber: 'Ordernummer',
    thankYou: 'Tack för din beställning!',
    orderConfirmation: 'Din beställning har skickats.',
    orderProcessing: 'Efter granskning av vårt team skickar vi en orderbekräftelse via e-post.',
    orderProcessingMessage: 'Din beställning har skickats. Efter granskning av vårt team skickar vi en orderbekräftelse via e-post.',
    continueShopping: 'Fortsätt handla',
    emptyCart: 'Din varukorg är tom',
    emptyCartMessage: 'Lägg till produkter i din varukorg för att fortsätta',
    stockWarning: 'Lagervarning',
    stockWarningDesc: 'Vissa artiklar har otillräckligt lager. Justera kvantiteter.',
    stockError: 'Lagerfel',
    stockErrorDesc: 'Det finns artiklar med otillräckligt lager. Justera kvantiteter.',
    refreshStock: 'Uppdatera lager',
    stockUpdated: 'Lager uppdaterat',
    stockUpdatedDesc: 'Lager har uppdaterats - {changed} artiklar ändrade',
    stockCheckDesc: 'Jämförelseresultat med inventering visas',
    stockOk: 'Lager OK',
    stockShortage: 'Lagerbrist',
    requestedQty: 'Begärd kvantitet',
    currentStock: 'Aktuellt lager',
    stockShortageMsg: 'Otillräckligt lager. Justera kvantiteten.',
    stockIssueWarning: 'Order kan inte bekräftas på grund av lagerproblem.',
    stockDataMissing: 'Lagerdata hämtas. Vänta ett ögonblick.',
    outOfStock: 'Slut i lager.',
    maxAvailable: 'Maximal',
    autoRestored: 'Kundvagn återställd',
    autoRestoredDesc: 'Varor från din senaste session har återställts',
    maxQuantityReached: 'Maximal lagerkvantitet uppnådd.',
    // ERP Contact Search
    contactSearch: 'Kundkontaktsökning',
    contactSearchDesc: 'Ange beställarens e-postadress för att hämta kontaktinformation',
    emailAddress: 'E-postadress',
    searchButton: 'Sök',
    searching: 'Söker',
    contactFound: 'Kontakt hittad',
    contactNotFound: 'Kontakt hittades inte',
    contactId: 'Knitido-kund-ID',
    companyName: 'Företag',
    contactPersonLabel: 'Kontaktperson',
    addressesFound: 'Hittade adresser',
    addressType: 'Typ',
    addressBilling: 'Faktureringsadress',
    addressDelivery: 'Leveransadress',
    vatSourceCompany: 'Företagsinfo',
    vatSourceBilling: 'Fakturering',
    vatSourceDelivery: 'Leverans',
    addressOther: 'Annat',
    addressDetails: 'Adress',
    loadingAddresses: 'Laddar adressinformation...',
    addressRetrieved: 'Adressinformation hämtad',
    addressNotFound: 'Adressinformation hittades inte',
    addressNotFoundDesc: 'Ingen registrerad adressinformation. Ange manuellt.',
    addressError: 'Adresshämtningsfel',
    addressErrorDesc: 'Kunde inte hämta adressinformation.',
    contactNotConfirmed: 'Kundkontakt inte bekräftad',
    contactNotConfirmedDesc: 'Ange en e-postadress och sök efter kontakten.',
    searchContact: 'Sök kontakt',
    inputError: 'Inmatningsfel',
    inputErrorDesc: 'Leveransinformation är ofullständig. Kontrollera.',
    processing: 'Bearbetar...',
    erpContactSearch: 'Kundkontaktsökning',
    contactSearchError: 'E-postadressen motsvarar ingen registrerad kontakt.',
    // Product Images Toggle
    showProductImages: 'Visa produktbilder',
    showProductImagesDesc: 'Visa produktbilder för bättre översikt (kan öka laddningstiden)',
    // System Registration Info
    systemRegistrationInfo: 'Din kundinformation',
    editShippingAddress: 'Redigera leveransadress',
    systemRegistrationInfoDesc: 'Din registrerade företagsinformation. Kontakta din representant om du behöver uppdatera faktureringsinformation.',
    // Order Summary
    regularPrice: 'Ordinarie grossistpris',
    offeredPrice: 'Erbjudet pris',
    discount: 'Rabatt',
    b2bCustomer: 'B2B-kund',
    pattern: 'Mönster',
    specialPriceApplied: 'Specialpris tillämpat',
    customerClassification: 'Kundklassificering',
    paymentCondition: 'Betalningsvillkor',
    invoice: 'Faktura (NET 30)',
    prepayment: 'Förskottsbetalning',
    paymentMethod: 'Betalningsmetod',
    invoicePayment: 'Fakturabetalning',
    estimatedSubtotal: 'Uppskattad delsumma',
    estimatedTotal: 'Uppskattad totalsumma',
    orderSummaryDisclaimer: 'Priserna som visas här är uppskattningar. När vi får din beställning granskar vi den och skickar en bindande orderbekräftelse med slutliga priser, fraktkostnader och moms via e-post.',
    searchError: 'Sökfel',
    searchErrorDesc: 'Ett fel uppstod under kontaktsökning.',
    confirmDeleteItem: 'Ta bort artikel',
    itemDeleted: 'Artikel borttagen',
    confirmDeleteItemDesc: 'Är du säker på att du vill ta bort följande artikel från din varukorg?',
    deleteConfirm: 'Ta bort',
    contactNotes: 'Kontaktanteckningar',
    contactNotesDesc: 'Har du några frågor eller särskilda önskemål? Låt oss veta (valfritt)',
    contactNotesLabel: 'Meddelande',
    contactNotesPlaceholder: 't.ex.: Produktfrågor, särskilda krav etc.',
    characters: 'tecken',
    contactIdLabel: 'Knitido-kund-ID',
    companyLabel: 'Företag',
    personLabel: 'Kontaktperson',
    emailLabel: 'E-post',
    addressTypeLabel: 'Typ',
    destinationLabel: 'Destination',
    // Shipping Form
    shippingTitle: 'Leveransinformation',
    shippingDesc: 'Ange leveransadressen för produkterna',
    companyRequired: 'Företag *',
    contactPersonRequired: 'Kontaktperson *',
    emailRequired: 'E-postadress *',
    phoneRequired: 'Telefonnummer *',
    addressRequired: 'Adress 1 *',
    address2: 'Adress 2 (Byggnad/Rum)',
    postalCodeRequired: 'Postnummer *',
    cityRequired: 'Stad *',
    countryRequired: 'Land *',
    selectCountry: 'Välj land',
    shippingMethodRequired: 'Leveransmetod *',
    selectShippingMethod: 'Välj leveransmetod',
    urgentDeliveryOption: 'Expressleverans (tilläggskostnader)',
    deliveryNotes: 'Leveransanteckningar',
    deliveryNotesPlaceholder: 'Ange önskad leveranstid eller andra önskemål',
    standardShipping: 'Standardfrakt (3-5 arbetsdagar)',
    expressShipping: 'Expressfrakt (1-2 arbetsdagar)',
    overnightShipping: 'Leverans över natten',
    germany: 'Tyskland',
    austria: 'Österrike',
    switzerland: 'Schweiz',
    japan: 'Japan',
    shippingAddressLabel: 'Leveransadress',
    changeDeliveryAddress: 'Ändra leveransadress',
    selectDeliveryAddress: 'Välj leveransadress',
    // Shipping Cost Details
    freeShipping: 'Fri frakt',
    shippingError: 'Fel',
    shippingZone: 'Fraktzon',
    remainingForFreeShipping: '{amount} kvar för fri frakt',
    moreForFreeShipping: 'mer för fri frakt',
    freeShippingProgress: 'Fri frakt vid',
    andAboveFreeShipping: 'och uppåt för fri frakt',
    freeShippingAchieved: 'Fri frakt tillämpas',
    threshold: 'och uppåt',
    nextShippingTier: 'Nästa fraktrabatt',
    moreForDiscount: 'mer för',
    shippingSavings: 'fraktbesparingar',
    orderAmountThreshold: 'och uppåt för',
    specialRegionNotice: 'Särskild fraktregion tillämpas',
    defaultShippingApplied: 'Standardfraktpriser tillämpas',
    requestedQuantity: 'Begärd kvantitet',
    availableQuantity: 'Tillgänglig kvantitet',
    orderSubmitError: 'Fel vid orderinlämning',
    orderSubmitErrorDesc: 'Det gick inte att skicka in beställningen',
    upload: {
      title: 'Importera Excel/CSV-beställning',
      description: 'Ladda upp en Excel- eller CSV-fil med dina beställningsdata',
      dragDropOrClick: 'Dra och släpp fil här eller klicka för att välja',
      dropHere: 'Släpp fil här',
      supportedFormats: 'Format som stöds: Excel (.xlsx, .xls) och CSV (.csv)',
      maxSize: 'Maximal filstorlek: {size} MB',
      processFile: 'Bearbeta fil',
      processing: 'Bearbetar fil...',
      ready: 'Fil klar för förhandsgranskning',
      readyDescription: 'Din fil har bearbetats framgångsrikt och är klar för granskning.',
      preview: 'Visa förhandsgranskning',
      errors: {
        fileTooLarge: 'Filen är för stor. Maxstorlek: {size} MB',
        invalidFileType: 'Ogiltig filtyp. Ladda upp en Excel- eller CSV-fil',
        uploadFailed: 'Fel vid uppladdning av fil',
      },
    },
    // Loading messages
    loadingPage: 'Laddar sida...',
    loadingStock: 'Kontrollerar produktlager...',
    loadingAccount: 'Laddar kontoinformation...',
    loadingError: 'Ett fel uppstod...',
    loadingData: 'Laddar data',
    // Toast messages
    addressRetrievedTitle: 'Adressinformation hämtad',
    addressSetAsDelivery: ' adress inställd som leveransdestination.',
    contactFoundDesc: ' identifierades.'
  },
  orderHistory: {
    title: 'Orderhistorik',
    searchPlaceholder: 'Sök efter ordernummer eller SKU...',
    noOrders: 'Inga beställningar hittades',
    noOrdersFound: 'Inga matchande beställningar hittades',
    startShopping: 'Visa produkter',
    orderItems: 'Orderartiklar',
    viewDetails: 'Detaljer',
    reorder: 'Beställ om',
    orderDate: 'Orderdatum',
    orderStatus: 'Status',
    orderTotal: 'Ordertotal',
    // Status translations
    statusPending: 'Väntar på betalning',
    statusProcessing: 'Bearbetar',
    statusConfirmed: 'Bekräftad',
    statusShipped: 'Skickad',
    statusDelivered: 'Levererad',
    statusCancelled: 'Avbruten',
    statusReturned: 'Returnerad',
    statusRefunded: 'Återbetalad',
    statusWarranty: 'Garanti',
    statusExchanged: 'Utbytt',
    statusRepair: 'Reparation',
    statusUnknown: 'Okänd',
    statusIncomplete: 'Ofullständig',
    statusWaitingPayment: 'Väntar på betalning',
    statusInPreparation: 'Under förberedelse',
    statusClearedShipping: 'Klar för frakt',
    statusBeingShipped: 'Skickas',
    statusOutgoingBooked: 'Utgående bokad',
    statusReturn: 'Retur',
    // Additional UI elements
    itemCount: 'artiklar',
    itemCountSingular: 'artikel',
    refreshButton: 'Uppdatera',
    errorFetchingOrders: 'Kunde inte hämta orderhistorik',
    // Payment status features
    paymentStatus: 'Betalningsstatus',
    markAsPaid: 'Markera som betald',
    unmarkAsPaid: 'Ta bort betalningsmarkering',
    paidOn: 'Betald den',
    paymentMarked: 'Betald',
    notPaid: 'Ej betald',
    paymentMarkedSuccess: 'Markerades som betald',
    paymentUnmarkedSuccess: 'Betalningsmarkering borttagen',
    paymentUpdateError: 'Kunde inte uppdatera betalningsstatus',
    // Payment date dialog
    paymentDateTitle: 'Ange betalningsinformation',
    paymentDateDescription: 'Ange betalningsinformation för order {orderNumber}',
    paymentDateLabel: 'Betalningsdatum',
    selectDate: 'Välj datum',
    paymentDateHelp: 'Välj datumet då banköverföringen gjordes',
    paymentMethodLabel: 'Betalningsmetod',
    bankTransfer: 'Banköverföring',
    invoice: 'Faktura',
    otherPayment: 'Annat',
    paymentReferenceLabel: 'Överföringsnamn / Referensnummer',
    paymentReferencePlaceholder: 't.ex. Anders Andersson, Överföring #12345',
    paymentReferenceHelp: 'Ange information som hjälper till att matcha med kontoutdrag',
    notesLabel: 'Anteckningar',
    notesPlaceholder: 'Ange ytterligare betalningsinformation',
    // Filter options
    filterByPaymentStatus: 'Filtrera efter betalningsstatus',
    allOrders: 'Alla beställningar',
    paidOrders: 'Betalda',
    unpaidOrders: 'Obetalda',
    // Sorting options
    sortBy: 'Sortera efter',
    sortByDate: 'Orderdatum',
    sortByPaymentDate: 'Betalningsdatum',
    sortByAmount: 'Belopp',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Orderdetaljer',
    notFound: 'Order hittades inte',
    backToHistory: 'Tillbaka till orderhistorik',
    orderDate: 'Orderdatum',
    orderItems: 'Orderartiklar',
    deliveryStatus: 'Leveransstatus',
    estimatedDelivery: 'Beräknad leverans',
    deliveredOn: 'Levererades',
    downloadInvoice: 'Ladda ner faktura',
    statusDelivered: 'Levererad',
    statusShipped: 'Skickad',
    statusConfirmed: 'Bekräftad',
    statusCancelled: 'Avbruten',
    errorFetchingDetails: 'Kunde inte hämta orderdetaljer',
  },
  company: {
    name: 'Affärspartner',
    tagline: 'Affärspartnersystem',
    copyright: '© 2025 Affärspartnersystem. Alla rättigheter förbehållna.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-post',
    countries: {
      DE: 'Tyskland',
      AT: 'Österrike',
      CH: 'Schweiz',
      FR: 'Frankrike',
      IT: 'Italien',
      ES: 'Spanien',
      NL: 'Nederländerna',
      BE: 'Belgien',
      PL: 'Polen',
      SE: 'Sverige',
      NO: 'Norge',
      FI: 'Finland',
      DK: 'Danmark',
      LT: 'Litauen',
      LV: 'Lettland',
      EE: 'Estland',
    },
  },
  cart: {
    newCart: 'Ny varukorg',
    currentCart: 'Aktuell varukorg',
    modified: 'ändrad',
    lastSaved: 'Senast sparad',
    unsavedChanges: 'osparade ändringar',
    saveCart: 'Spara varukorg',
    loadCart: 'Ladda varukorg',
    deleteCart: 'Ta bort varukorg',
    startNewCart: 'Starta ny varukorg',
    savedCarts: 'Sparade varukorgar',
    cartSaved: 'Varukorg sparad',
    cartDeleted: 'Varukorg borttagen',
    confirmDeleteCart: 'Ta bort varukorg?\n\nDenna åtgärd kan inte ångras.',
    confirmSwitchCart: 'Den aktuella varukorgen har osparade ändringar.\n\nAtt ladda en annan varukorg kommer att förlora de aktuella ändringarna.\n\nFortsätt?',
    confirmSwitchCartTitle: 'Byt varukorg',
    confirmNewCart: 'Den aktuella varukorgen har osparade ändringar.\n\nAtt starta en ny varukorg kommer att förlora de aktuella ändringarna.\n\nFortsätt?',
    confirmNewCartTitle: 'Starta ny varukorg',
    confirmClearCart: 'Rensa varukorg?\n\n{count} artiklar kommer att tas bort.\n\nDenna åtgärd kan inte ångras.',
    confirmClearCartTitle: 'Rensa varukorg',
    autoSaved: 'Autosparad',
    itemsWillBeRemoved: 'artiklar kommer att tas bort',
    changesWillBeLost: 'ändringar kommer att förloras',
    continueQuestion: 'Fortsätt?',
    cartStatus: 'Varukorgsstatus',
    cartName: 'Varukorgsnamn',
    cartNamePlaceholder: 't.ex.: Månadsslutsbeställning',
    cartNameRequired: 'Ange ett varukorgsnamn',
    saveCartDescription: 'Ge den aktuella varukorgen ett namn och spara den. Du kan ladda den senare.',
    cancelCart: 'Avbryt varukorg',
    proceedToCheckout: 'Gå till kassan',
    emptyCart: 'Varukorgen är tom',
    erpDown: 'Beställningssystemet är nere. Försök igen senare.',
    erpDegraded: 'Systemet är för närvarande instabilt. Beställningar kan misslyckas.',
    erpDownSaveHint: 'Spara din kundvagn och beställ när systemet är återställt.',
    erpSaveCart: 'Spara kundvagn',
  },
  nav: {
    dashboard: 'Översikt',
    products: 'Produkter',
    orderHistory: 'Beställningar',
    account: 'Kontoinformation',
    bulkImport: 'Massimport',
  },
  settings: {
    selectLanguage: 'Välj ett språk',
    languagePreferenceSaved: 'Ditt val kommer att sparas på ditt konto för framtida besök.',
  },
  reorder: {
    allItemsAdded: '{count} artiklar har lagts till i varukorgen',
    partialSuccess: '{added} artiklar lades till. {failed} artiklar kunde inte läggas till',
    allItemsFailed: 'Kunde inte lägga till artiklar i varukorgen',
    error: 'Ett fel uppstod under ombeställning',
    itemDiscontinued: '{name} ({color}/{size}) har utgått',
    itemOutOfStock: '{name} ({color}/{size}) är slut i lager',
    partialStock: '{name} ({color}/{size}) endast {available} tillgängliga',
    confirmReorder: 'Bekräfta ombeställning',
    confirmReorderMessage: 'Lägg till artiklar från denna beställning i din varukorg?',
    addingToCart: 'Lägger till i varukorg...',
    checkingStock: 'Kontrollerar lager...',
    checkoutTitle: 'Artiklar tillagda i varukorg',
    checkoutDescription: '{count} artiklar har lagts till i din varukorg. Vill du gå till kassan?',
  },
  bulkImport: {
    instructions: 'Så här importerar du beställningar',
    step1: 'Ladda ner ordermallsfilen',
    step2: 'Fyll i dina beställningsdata med SKU och kvantitet',
    step3: 'Spara som Excel (.xlsx) eller CSV-fil',
    step4: 'Ladda upp filen med formuläret nedan',
    step5: 'Granska och bekräfta din beställning',
    downloadTemplate: 'Ladda ner mall',
    downloadExcelTemplate: 'Ladda ner Excel-mall',
    downloadCsvTemplate: 'Ladda ner CSV-mall',
    formatGuide: 'Filformatguide',
    requiredColumns: 'Obligatoriska kolumner',
    skuDescription: 'Produkt-SKU-kod',
    quantityDescription: 'Beställningskvantitet (positivt heltal)',
    optionalColumns: 'Valfria kolumner',
    notesDescription: 'Interna anteckningar (t.ex. PO-nummer, referens) - endast för dina register',
    formatNote: 'Första raden ska innehålla kolumnrubriker. Data börjar från andra raden.',
    parseSuccess: 'Framgångsrikt tolkat {count} artiklar från filen',
    parseError: 'Tolkningsfel',
    validationError: 'Valideringsfel',
    validationErrorGuidance: 'Klicka på knappen "{showPreviewButton}" för att granska detaljerna.',
    warnings: 'Varningar',
    itemsParsed: 'Framgångsrikt tolkat {count} artiklar:',
    andMore: '...och {count} fler artiklar',
    validationSummary: 'Valideringssammanfattning',
    duplicateSKUs: 'Dubblerade SKU:er hittade',
    skuFormat: 'SKU får endast innehålla bokstäver, siffror och bindestreck',
    quantityRange: 'Kvantitet måste vara mellan 1 och 9999',
    maxRows: 'Maximalt 1000 rader tillåtet',
    rowsSkipped: '{count} rader hoppades över på grund av fel',
    previewTitle: 'Orderförhandsgranskning',
    previewDescription: 'Granska och redigera dina beställningsdata innan du fortsätter',
    proceedToCart: 'Lägg till i varukorg',
    // File parsing messages
    fileEmpty: 'Filen är tom eller innehåller inga data',
    fileTooManyRows: 'Filen innehåller för många rader ({current}). Maximum tillåtet: {max}',
    invalidRowFormat: 'Ogiltigt radformat',
    missingColumns: 'Obligatoriska kolumner saknas (SKU och Kvantitet)',
    missingSku: 'SKU saknas',
    invalidSkuFormat: 'Ogiltigt SKU-format: "{sku}" (måste matcha mönster: {pattern})',
    skuTooLong: 'SKU för lång: "{sku}" (maximalt 50 tecken)',
    invalidQuantity: 'Ogiltig kvantitet: "{quantity}" är inte ett nummer',
    quantityTooLow: 'Kvantitet för låg: {quantity} (minimum: {min})',
    quantityTooHigh: 'Kvantitet för hög: {quantity} (maximum: {max})',
    notesRequired: 'Anteckningsfält krävs',
    noValidData: 'Ingen giltig data hittades. Kontrollera filformatet.',
    row: 'Rad {row}: {errors}',
    rowErrors: '...och {count} fler fel',
    duplicateSkuInRows: 'Dubblett-SKU "{sku}" hittad i rader: {rows}',
    quantityExceedsMax: 'Rad {row}: Kvantitet {quantity} överskrider maximalt tillåtet ({max})',
    quantityBelowMin: 'Rad {row}: Kvantitet {quantity} är under minimum som krävs ({min})',
    // Validation messages
    unsupportedFileFormat: 'Filformatet stöds inte. Ladda upp en CSV- eller Excel-fil.',
    csvParsingErrors: 'CSV-tolkningsfel uppstod',
    failedToParseFile: 'Kunde inte tolka fil',
    failedToParseExcel: 'Kunde inte tolka Excel-fil',
    failedToReadFile: 'Kunde inte läsa fil',
    unknownError: 'Okänt fel uppstod',
    totalRows: 'Totalt antal rader',
    valid: 'Giltiga',
    invalid: 'Ogiltiga',
    skipped: 'Överhoppade',
    // SKU validation
    skuValidationError: 'SKU-valideringsfel',
    skuValidationFailed: 'Kunde inte validera SKU:er. Du kan fortfarande fortsätta men vissa artiklar kanske inte är tillgängliga.',
    skuNotFound: 'SKU hittades inte i databasen',
    skusNotFound: '{count} SKU:er hittades inte i databasen',
    itemsHaveInsufficientStock: '{count} artiklar har otillräckligt lager',
    validatingSKUs: 'Validerar artiklar...',
    unvalidatedChanges: 'Du har ovaliderade ändringar. Validera om innan du lägger till i varukorgen.',
    revalidate: 'Validera om',
    validating: 'Validerar...',
    validationSuccess: 'Alla artiklar är giltiga',
    validationComplete: 'Validering klar',
    validationResultSummary: '{errors} fel, {warnings} varningar hittade',
    // Table headers
    actions: 'Åtgärder',
    notes: 'Anteckningar',
    // Status filter
    all: 'Alla',
    hasErrors: 'Har fel',
    // Selection summary
    selected: 'vald',
    errors: 'fel',
    // Pagination
    page: 'Sida {current} av {total}',
    previous: 'Föregående',
    next: 'Nästa',
    noResults: 'Inga resultat.',
    // Cart integration
    noValidItems: 'Inga giltiga artiklar',
    allItemsHaveErrors: 'Alla artiklar har valideringsfel. Rätta till dem innan du fortsätter.',
    dataLoadingError: 'Dataladdningsfel',
    failedToLoadProductData: 'Kunde inte ladda produktdata. Försök igen.',
    itemsAddedToCart: '{count} artiklar tillagda i varukorg',
    itemsAddedMessage: 'La till {count} artiklar i varukorgen',
    someSkusNotFound: '{count} SKU:er kunde inte hittas.',
    noItemsAdded: 'Inga artiklar tillagda',
    couldNotFindProducts: 'Kunde inte hitta några produkter som matchar SKU:erna.',
    errorAddingToCart: 'Fel',
    failedToAddToCart: 'Kunde inte lägga till artiklar i varukorgen. Försök igen.',
    addingToCart: 'Lägger till i varukorg...',
    // File info
    fileSelected: '{name} vald för bearbetning',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Mallnedladdning',
    templateWillBeImplemented: 'Mallnedladdning kommer att implementeras i fas 7',
    // Additional validation
    validationFailed: 'Validering misslyckades',
    // Template download
    templateDownloaded: 'Mallen laddades ner framgångsrikt',
    templateDownloadError: 'Kunde inte ladda ner mall',
    // Template content
    sheetName: 'Massbeställning',
    instructionsSheetName: 'Instruktioner',
    columnDescriptions: 'Kolumnbeskrivningar:',
    columnHeader: 'Kolumn',
    columnRequired: 'Obligatorisk',
    columnOptional: 'Valfri',
    columnDescription: 'Beskrivning',
    templateNotes: 'Anteckningar:',
    templateNote1: 'Första raden måste innehålla kolumnrubriker exakt som visas',
    templateNote2: 'Data börjar från rad 2',
    templateNote3: 'SKU måste matcha befintliga produktkoder i systemet',
    templateNote4: 'Kvantitet måste vara ett positivt heltal mellan 1 och 9999',
    templateNote5: 'Maximalt 1000 rader tillåtet per fil',
    templateNote6: 'Spara som .xlsx- eller .csv-format',
    stockAvailabilityWarning: 'Faktisk lagertillgänglighet kommer att kontrolleras på nästa kassasida.',
    outOfStock: 'Slut i lager',
    insufficientStock: 'Otillräckligt lager: {available} tillgängligt, {requested} begärt',
  },
  orderExport: {
    export: 'Exportera beställning',
    exportOrder: 'Exportera beställningsdata',
    exportAsCSV: 'Exportera som CSV',
    exportAsExcel: 'Exportera som Excel',
    exportForReorder: 'Exportera för massimport',
    detailed: 'Fullständiga detaljer',
    simpleFormat: 'Importformat',
  },
};